import Course from './course'

export default Course
